import { z } from 'zod';

/**
 * Auth credentials — single source of truth for shape and validation.
 * Used both client-side (form validation) and as type for use-cases.
 *
 * Password rules are intentionally lax for v0.5 (8+ chars, no special-char
 * gymnastics) — gym users on a phone with one hand will appreciate it.
 * Strengthen later if abuse appears.
 */
export const credentialsSchema = z.object({
  email: z.email({ message: 'Введите корректный email' }),
  password: z
    .string()
    .min(8, { message: 'Пароль должен быть не короче 8 символов' })
    .max(72, { message: 'Пароль слишком длинный' }),
});

export type Credentials = z.infer<typeof credentialsSchema>;

export const signUpSchema = credentialsSchema.extend({
  displayName: z
    .string()
    .trim()
    .min(1, { message: 'Введите имя' })
    .max(60, { message: 'Имя слишком длинное' }),
});

export type SignUpInput = z.infer<typeof signUpSchema>;
